import angular from "angular";
import template from "./admin-create-staff.html";
import AdminStaffCreateController from "./admin-create-staff.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.staff.create", {
    url: "/create",
    controller: AdminStaffCreateController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.staff.create", [])
  .config(config)
  .controller("AdminStaffCreateController", AdminStaffCreateController);
